// Helper to determine if debugging is enabled
function isDebuggingEnabled() {
  return (
    window.DEBUGGING === true ||
    window.location.search.includes("debug=true") ||
    window.location.hostname === "localhost" ||
    window.location.hostname.includes("preview")
  );
}

// Enhanced console logger that only logs when debugging is enabled
const logger = {
  log: function (...args) {
    if (isDebuggingEnabled()) {
      console.log(...args);
    }
  },
  warn: function (...args) {
    if (isDebuggingEnabled()) {
      console.warn(...args);
    }
  },
  error: function (...args) {
    if (isDebuggingEnabled()) {
      console.error(...args);
    }
  },
};

// LocalStorageManager for handling localStorage with expiry
const LocalStorageManager = {
  setWithExpiry(key, value, ttl) {
    const item = {
      value: value,
      expiry: new Date().getTime() + ttl * 24 * 60 * 60 * 1000, // Convert days to milliseconds
    };
    localStorage.setItem(key, JSON.stringify(item));
  },

  getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);
      const now = new Date().getTime();

      if (now > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      return item.value;
    } catch (e) {
      return null;
    }
  },

  removeItem(key) {
    localStorage.removeItem(key);
  },
};

// Main QuizStart object to handle quiz initialization and clerk auto-login
const QuizStart = {
  // Initialize the quiz start page
  init() {
    logger.log("Initializing QuizStart...");
    this.handleQuizButtons();
    this.bindEvents();
    this.initClerkAutoLogin();
    this.initQuizHomeForm();

    if (isDebuggingEnabled()) {
      this.createDebugPanel();
    }
  },

  // Handle quiz buttons based on localStorage
  handleQuizButtons() {
    const quizAnswers = LocalStorageManager.getWithExpiry("kandyQuizAnswers");

    const isQuizCompleted = quizAnswers && quizAnswers.isCompleted === true;

    const $offerButton = $(".qz_start_btn.toOffer");
    const $quizButton = $(".qz_start_btn").not(".toOffer").first();
    const $quizButtonsRest = $(".qz_start_btn")
      .not(".toOffer")
      .not($quizButton);

    if (isQuizCompleted) {
      // Show offer button and fade quiz button if completed answers exist
      $offerButton.show();
      $quizButton.addClass("faded").text("Iniciar um Novo Quiz");
      $quizButtonsRest.each((index, element) => {
        element.href = $offerButton.first().attr("href");
        element.textContent = $offerButton.first().text();
      });
    } else {
      // Hide offer button and ensure quiz button is prominent
      $offerButton.hide();
      $quizButton
        .removeClass("faded")
        .text($quizButton.data("text") || "Iniciar Quiz");
      $quizButtonsRest.each((index, element) => {
        element.href = $quizButton.attr("href");
        element.textContent = $quizButton.text();
      });
    }
  },

  // Initialize and handle the home quiz form functionality
  initQuizHomeForm() {
    const $form = $(".qz_home_form");
    console.log("Found form?", $form.length);
    if (!$form.length) return;

    const $nameInput = $form.find('[data-question-type="name"] input');
    const $ageOptions = $form.find(
      '[data-question-type="age"] input[type="radio"]'
    );
    const $submitBtn = $form.find(".qz_home_form_btn");
    const $nameErrorMessage = $form
      .find('[data-question-type="name"]')
      .data("error-message");
    const $ageErrorMessage = $form
      .find('[data-question-type="age"]')
      .data("error-message");

    if (!$submitBtn.length) return;

    $submitBtn.on("click", (e) => {
      e.preventDefault();

      const dogName = $nameInput.val().trim();
      const dogAge = $ageOptions.filter(":checked").val();
      let isValid = true;

      if ($nameInput.length && !dogName) {
        isValid = false;
        this.showFormError($nameInput, $nameErrorMessage);
      } else if ($nameInput.length) {
        this.clearFormError($nameInput);
      }
      if ($ageOptions.length && !dogAge) {
        isValid = false;
        this.showFormError(
          $ageOptions.first().closest(".qz_home_form_question"),
          $ageErrorMessage
        );
      } else if ($ageOptions.length) {
        this.clearFormError(
          $ageOptions.first().closest(".qz_home_form_question")
        );
      }

      if (!isValid) return;

      // Clear existing quiz data
      localStorage.removeItem("kandyQuizAnswers");
      localStorage.removeItem("kandyDogDetails");
      localStorage.removeItem("kandyProductVariant");
      localStorage.removeItem("kandyTrialVariant");

      // Store dog details and partial quiz answers
      const dogDetails = { name: dogName, age: dogAge };
      const quizAnswers = { isCompleted: false, ...dogDetails };
      LocalStorageManager.setWithExpiry("kandyDogDetails", dogDetails, 30);
      LocalStorageManager.setWithExpiry("kandyQuizAnswers", quizAnswers, 30);

      //window.location.href = $submitBtn.attr("href");

      const href = $submitBtn.attr("href");

      console.log("href", href);

      if (href && typeof href === "string") {
        window.location.href = href;
      } else {
        console.error("Invalid href for redirect:", href);
      }
    });
  },

  // Show form error on invalid fields
  showFormError($element, message) {
    $element.addClass("error");
    const $question = $element.closest(".qz_home_form_question");

    // Create or update error message
    let $errorMsg = $question.find(".form-error-message");
    if (!$errorMsg.length) {
      $errorMsg = $(
        '<div class="form-error-message" style="color: red; font-size: 12px; line-height: 1;"></div>'
      );
      $question.append($errorMsg);
    }
    $errorMsg.text(message);
  },

  // Clear form error
  clearFormError($element) {
    $element.removeClass("error");
    const $question = $element.closest(".qz_home_form_question");
    const $errorMsg = $question.find(".form-error-message");
    if ($errorMsg.length) {
      $errorMsg.remove();
    }
  },

  // Bind event handlers
  bindEvents() {
    // Clear storage when starting a new quiz
    $(".qz_start_btn")
      .not(".toOffer")
      .first()
      .on("click", () => {
        localStorage.removeItem("kandyQuizAnswers");
        localStorage.removeItem("kandyDogDetails");
        localStorage.removeItem("kandyProductVariant");
        localStorage.removeItem("kandyTrialVariant");
      });
  },

  // Clerk Auto Login functionality
  ClerkAutoLogin: {
    // Check if Clerk is properly loaded
    isClerkLoaded() {
      return typeof window.Clerk !== "undefined" && window.Clerk !== null;
    },

    // Wait for Clerk to be loaded
    waitForClerk(maxAttempts = 20, interval = 500) {
      return new Promise((resolve) => {
        let attempts = 0;

        const checkClerk = () => {
          attempts++;
          logger.log(
            `Checking if Clerk is loaded (attempt ${attempts}/${maxAttempts})...`
          );

          if (this.isClerkLoaded()) {
            logger.log("Clerk is loaded and ready");
            resolve(true);
            return;
          }

          if (attempts >= maxAttempts) {
            logger.warn("Max attempts reached waiting for Clerk to load");
            resolve(false);
            return;
          }

          setTimeout(checkClerk, interval);
        };

        checkClerk();
      });
    },

    // Get checkout data from localStorage
    getCheckoutData() {
      const checkoutComplete = window.localStorage.getItem("checkout_complete");
      const checkoutEmail = window.localStorage.getItem("checkout_email");
      const checkoutAttributes = window.localStorage.getItem(
        "checkout_attributes"
      );

      if (!checkoutComplete || !checkoutEmail || !checkoutAttributes) {
        logger.log("Missing checkout data:", {
          checkoutComplete: !!checkoutComplete,
          checkoutEmail: !!checkoutEmail,
          checkoutAttributes: !!checkoutAttributes,
        });
        return null;
      }

      try {
        const attributes = JSON.parse(checkoutAttributes);
        const formId = attributes.find((attr) => attr.key === "formId")?.value;
        if (!formId) {
          logger.warn("Form ID not found on checkout attributes");
          return null;
        }

        logger.log("Successfully parsed checkout data:", {
          email: checkoutEmail,
          formId,
        });
        return {
          email: checkoutEmail,
          formId: formId,
        };
      } catch (e) {
        logger.error("Error parsing checkout data", e);
        return null;
      }
    },

    // Create debug checkout data for testing
    createDebugData(email = "test@example.com", formId = "test-form-id") {
      logger.log("Creating debug checkout data with:", { email, formId });

      // Set checkout data in localStorage
      localStorage.setItem("checkout_complete", "true");
      localStorage.setItem("checkout_email", email);

      // Create checkout attributes with formId
      const attributes = [
        { key: "formId", value: formId },
        { key: "order_trial", value: "true" },
      ];
      localStorage.setItem("checkout_attributes", JSON.stringify(attributes));

      logger.log(
        "Debug checkout data created. You can now use clerkAuth.autoLogin()"
      );
      return { email, formId };
    },

    // Clear debug checkout data
    clearDebugData() {
      localStorage.removeItem("checkout_complete");
      localStorage.removeItem("checkout_email");
      localStorage.removeItem("checkout_attributes");
      logger.log("Debug checkout data cleared.");
    },

    // Initialize the auto-login process
    async init() {
      logger.log("Initializing ClerkAutoLogin...");

      // Debug: Check if clerkAuth global is available
      logger.log(
        "clerkAuth available:",
        typeof window.clerkAuth !== "undefined"
      );
      logger.log("Clerk available:", typeof window.Clerk !== "undefined");

      if (!window.clerkAuth) {
        logger.warn("clerkAuth not available, cannot attempt auto-login");
        return;
      }

      logger.log("clerkAuth from custom-auth.js is available");

      // Check for checkout data and attempt auto-login if data exists
      const checkoutData = this.getCheckoutData();
      logger.log("Retrieved checkout data:", checkoutData);
      if (!checkoutData) {
        logger.log("No checkout data found, skipping auto-login");
        return;
      }

      logger.log("Found checkout data, scheduling auto-login attempt...");
      // Give the page some time to fully load before attempting login
      setTimeout(() => this.attemptLogin(checkoutData), 1500);
    },

    // Attempt to login with checkout data
    async attemptLogin(checkoutData) {
      try {
        logger.log("Starting auto-login attempt with:", checkoutData);
        const clerkLoaded = await this.waitForClerk();

        if (!clerkLoaded) {
          logger.error("Clerk failed to load after waiting");
          return;
        }

        const hasActiveSession = window.Clerk?.session?.status === "active";
        logger.log(
          "Current Clerk session status:",
          window.Clerk?.session?.status
        );

        if (hasActiveSession) {
          logger.log("User already has an active Clerk session");
          return;
        }

        logger.log("Attempting to sign in using checkout data credentials");
        const signInResult = await window.clerkAuth.clerkSignin(
          checkoutData.email,
          checkoutData.formId
        );
        logger.log("Sign-in result:", signInResult);

        if (signInResult.ok) {
          logger.log("Sign-in successful, now calling autoLogin");
          const autoLoginResult = await window.clerkAuth.autoLogin();
          logger.log("autoLogin result after signin:", autoLoginResult);
        } else {
          logger.error("Sign-in failed with code:", signInResult.code);
        }
      } catch (error) {
        logger.error("Error during auto-login process:", error);
      }
    },
  },

  // Initialize the Clerk Auto Login process
  initClerkAutoLogin() {
    this.ClerkAutoLogin.init();
  },

  // Create debug panel for testing auto-login
  createDebugPanel() {
    logger.log("Creating debug panel");
    const debugPanel = document.createElement("div");
    debugPanel.id = "clerk-debug-panel";
    debugPanel.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      padding: 0;
      background: white;
      border: 1px solid #e0e0e0;
      border-radius: 3px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      z-index: 9999;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      max-width: 300px;
      transition: all 0.2s ease;
      width: 20px;
      height: 20px;
    `;

    const collapseBtn = document.createElement("div");
    collapseBtn.id = "debug-panel-collapse";
    collapseBtn.innerHTML =
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 15L12 9L6 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    collapseBtn.style.cssText = `
      width: 20px;
      height: 20px;
      background: white;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
    `;

    const debugContent = document.createElement("div");
    debugContent.id = "debug-panel-content";
    debugContent.style.display = "none";
    debugContent.innerHTML = `
      <h4 style="margin-top: 0; margin-bottom: 10px; font-size: 16px; color: #212529;">Clerk Debug Panel</h4>
      <div style="margin-bottom: 10px;">
        <label style="display: block; margin-bottom: 5px; font-size: 14px;">Email:</label>
        <input type="email" id="debug-email" value="test@example.com" style="width: 100%; padding: 5px; font-size: 14px; border: 1px solid #ced4da; border-radius: 3px;">
      </div>
      <div style="margin-bottom: 15px;">
        <label style="display: block; margin-bottom: 5px; font-size: 14px;">Form ID:</label>
        <input type="text" id="debug-form-id" value="test-form-id" style="width: 100%; padding: 5px; font-size: 14px; border: 1px solid #ced4da; border-radius: 3px;">
      </div>
      <div style="display: flex; gap: 10px; flex-wrap: wrap;">
        <button id="create-debug-data" style="padding: 6px 12px; background: #0d6efd; color: white; border: none; border-radius: 3px; cursor: pointer; font-size: 14px;">Create Data</button>
        <button id="clear-debug-data" style="padding: 6px 12px; background: #dc3545; color: white; border: none; border-radius: 3px; cursor: pointer; font-size: 14px;">Clear Data</button>
        <button id="auto-login" style="padding: 6px 12px; background: #198754; color: white; border: none; border-radius: 3px; cursor: pointer; font-size: 14px;">Auto Login</button>
        <button id="check-state" style="padding: 6px 12px; background: #6c757d; color: white; border: none; border-radius: 3px; cursor: pointer; font-size: 14px;">Check State</button>
      </div>
      <div id="debug-status" style="margin-top: 10px; font-size: 12px; color: #6c757d;"></div>
    `;

    debugPanel.appendChild(collapseBtn);
    debugPanel.appendChild(debugContent);
    document.body.appendChild(debugPanel);

    // Handle collapse/expand functionality
    let isCollapsed = true;
    collapseBtn.addEventListener("click", () => {
      isCollapsed = !isCollapsed;
      if (isCollapsed) {
        debugContent.style.display = "none";
        collapseBtn.innerHTML =
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 15L12 9L6 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        debugPanel.style.padding = "0";
        debugPanel.style.width = "20px";
        debugPanel.style.height = "20px";
        debugPanel.style.border = "1px solid #e0e0e0";
        debugPanel.style.background = "white";
        debugPanel.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
        collapseBtn.style.position = "static";
        collapseBtn.style.borderRadius = "3px";
      } else {
        debugContent.style.display = "block";
        collapseBtn.innerHTML =
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        debugPanel.style.padding = "15px";
        debugPanel.style.width = "";
        debugPanel.style.height = "";
        debugPanel.style.border = "1px solid #dee2e6";
        debugPanel.style.background = "#f8f9fa";
        debugPanel.style.boxShadow = "0 0 10px rgba(0,0,0,0.1)";
        collapseBtn.style.position = "absolute";
        collapseBtn.style.top = "10px";
        collapseBtn.style.right = "10px";
      }
    });

    this.bindDebugPanelEvents();
  },

  // Bind events for the debug panel
  bindDebugPanelEvents() {
    document
      .getElementById("create-debug-data")
      .addEventListener("click", () => {
        const email = document.getElementById("debug-email").value;
        const formId = document.getElementById("debug-form-id").value;
        this.ClerkAutoLogin.createDebugData(email, formId);
        document.getElementById("debug-status").innerHTML = `
        <div style="margin-top: 5px;">Data created: ${new Date().toLocaleTimeString()}</div>
        <div>Email: ${email}</div>
        <div>Form ID: ${formId}</div>
        <div>You can now use clerkAuth.autoLogin()</div>
      `;
      });

    document
      .getElementById("clear-debug-data")
      .addEventListener("click", () => {
        this.ClerkAutoLogin.clearDebugData();
        document.getElementById("debug-status").innerHTML = `
        <div style="margin-top: 5px;">Data cleared: ${new Date().toLocaleTimeString()}</div>
      `;
      });

    document.getElementById("auto-login").addEventListener("click", () => {
      if (window.clerkAuth) {
        const checkoutData = this.ClerkAutoLogin.getCheckoutData();
        if (checkoutData) {
          document.getElementById("debug-status").innerHTML = `
            <div style="margin-top: 5px;">Starting login attempt: ${new Date().toLocaleTimeString()}</div>
          `;
          window.clerkAuth
            .clerkSignin(checkoutData.email, checkoutData.formId)
            .then((result) => {
              if (result.ok) {
                document.getElementById("debug-status").innerHTML += `
                  <div>Sign-in successful, now calling autoLogin</div>
                `;
                window.clerkAuth.autoLogin().then((autoLoginResult) => {
                  document.getElementById("debug-status").innerHTML += `
                      <div>autoLogin completed with result: ${
                        autoLoginResult ? "success" : "failed"
                      }</div>
                    `;
                });
                document.getElementById("debug-status").innerHTML += `
                  <div>Email: ${checkoutData.email}</div>
                  <div>FormId: ${checkoutData.formId}</div>
                `;
              } else {
                document.getElementById("debug-status").innerHTML += `
                  <div style="color: #dc3545;">Error: Login failed with code: ${result.code}</div>
                `;
              }
            })
            .catch((error) => {
              document.getElementById("debug-status").innerHTML += `
                <div style="color: #dc3545;">Error during sign-in: ${error.message}</div>
              `;
            });
        } else {
          document.getElementById("debug-status").innerHTML = `
            <div style="margin-top: 5px; color: #dc3545;">Error: No checkout data available</div>
          `;
        }
      } else {
        document.getElementById("debug-status").innerHTML = `
          <div style="margin-top: 5px; color: #dc3545;">Error: clerkAuth not available</div>
        `;
      }
    });

    document.getElementById("check-state").addEventListener("click", () => {
      const statusEl = document.getElementById("debug-status");
      const checkoutData = this.ClerkAutoLogin.getCheckoutData();

      statusEl.innerHTML = `
        <div style="margin-top: 5px;">Current State: ${new Date().toLocaleTimeString()}</div>
        <div>clerkAuth available: ${
          typeof window.clerkAuth !== "undefined"
        }</div>
        <div>Clerk available: ${typeof window.Clerk !== "undefined"}</div>
        <div>Clerk Session: ${
          window.Clerk?.session ? window.Clerk.session.status : "none"
        }</div>
        <div>Checkout data: ${checkoutData ? "Found" : "None"}</div>
      `;

      if (checkoutData) {
        statusEl.innerHTML += `
          <div>- Email: ${checkoutData.email}</div>
          <div>- FormId: ${checkoutData.formId}</div>
        `;
      }
    });
  },
};

// Initialize on document ready
$(document).ready(() => {
  console.log("init quiz start");
  QuizStart.init();
});
